import * as e from "react";
const c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "VA_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#VA_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h14v24H0V0z",
      fill: "#FFDC17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.783 12.751l-.346.023c.083 1.185.338 2.101.77 2.748.697 1.042 1.617 1.848 2.233 1.848.14 0 .172.052.126.18-.065.183-.273.362-.54.43-.443.115-1.453.174-3.01.174v.335c1.589 0 2.616-.06 3.1-.185.375-.097.673-.354.777-.644.12-.335-.061-.625-.453-.625-.457 0-1.306-.743-1.943-1.695-.395-.592-.636-1.455-.714-2.589zM21.147 12.751l.345.023c-.082 1.185-.337 2.101-.77 2.748-.697 1.042-1.617 1.848-2.232 1.848-.14 0-.173.052-.127.18.066.183.274.362.54.43.444.115 1.453.174 3.011.174v.335c-1.589 0-2.616-.06-3.1-.185-.375-.097-.673-.354-.777-.644-.12-.335.061-.625.453-.625.457 0 1.305-.743 1.942-1.695.396-.592.636-1.455.715-2.589z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.066 6.798l-9.14 7.126a3.343 3.343 0 00-1.034-.162c-1.483 0-2.724.948-2.724 2.177 0 1.23 1.241 2.177 2.724 2.177.17 0 .338-.012.5-.037a.958.958 0 01-.318-.42c-.067-.186-.04-.36.065-.476-.08.008-.163.012-.247.012-1 0-1.773-.59-1.773-1.256s.773-1.256 1.773-1.256c1.001 0 1.773.59 1.773 1.256 0 .204-.072.4-.201.576l.074-.067c.316-.296-.396.921-1.011.921-.14 0-.172.052-.126.18.061.172.247.34.49.417 1.002-.314 1.726-1.088 1.726-2.027a1.84 1.84 0 00-.334-1.05l4.913-4.17.33.341.236-.215.82.609-.342.264.7.851 1.416-1.09.02-.011-.003-.003.088-.068-.7-.851-.34.261-.917-.634.107-.098-.295-.305.444-.377.236.244.253-.23.795.63-.335.258.7.851 1.21-.932.14-.077-.02-.016.19-.147-.7-.851-.395.305-.87-.669.118-.107-.203-.21.904-.766-.717-.878z",
      fill: "#F4B300"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.687 14.725c.262 0 .475-.168.475-.377 0-.208-.213-.376-.475-.376-.263 0-.476.168-.476.376s.213.377.476.377zm.173 3.433c.263 0 .476-.169.476-.377s-.213-.377-.476-.377c-.262 0-.475.169-.475.377s.213.377.475.377zm4.712-.377c0 .208-.212.377-.475.377s-.476-.169-.476-.377.213-.377.476-.377c.262 0 .475.169.475.377zM23.385 15.938c0-.552.251-1.048.662-1.426l-5.25-4.065-.06.047.154.138-.414.428-.218-.198-.804.62.307.236-.7.851-1.403-1.08-.034-.021.004-.003-.088-.068.7-.851.34.261.917-.634-.107-.098.397-.41-.463-.358-.319.33-.243-.221-.785.636.315.242-.7.851-1.166-.898-.184-.11.02-.016-.19-.148.7-.85.395.304.87-.668-.118-.108.24-.247-.942-.729.595-.719 9.08 7.033a3.306 3.306 0 011.217-.227c1.483 0 2.724.947 2.724 2.176 0 1.23-1.241 2.177-2.724 2.177-.17 0-.337-.012-.5-.036a.957.957 0 00.318-.42c.068-.187.04-.36-.066-.477.08.008.163.012.248.012 1 0 1.773-.59 1.773-1.255 0-.667-.773-1.256-1.773-1.256-1.001 0-1.773.59-1.773 1.255 0 .205.073.403.203.578a5.098 5.098 0 01-.076-.068c-.316-.296.396.921 1.011.921.14 0 .172.052.126.18-.061.171-.246.34-.489.416-1.003-.313-1.727-1.088-1.727-2.027z",
      fill: "#BFBFBF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.315 14.725c-.262 0-.475-.168-.475-.377 0-.208.213-.376.475-.376.263 0 .476.168.476.376s-.213.377-.476.377zm-.174 3.433c-.262 0-.475-.169-.475-.377s.213-.377.476-.377c.262 0 .475.169.475.377s-.213.377-.476.377zm-4.711-.377c0 .208.212.377.475.377s.476-.169.476-.377-.213-.377-.476-.377-.476.169-.476.377z",
      fill: "#F4B300"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.741 11.795a.13.13 0 00-.13.13v.54h-.48a.126.126 0 000 .25h.48v7.155c0 .072.058.13.13.13h.26a.13.13 0 00.13-.13v-7.154h.738a.126.126 0 000-.251h-.739v-.54a.13.13 0 00-.13-.13h-.259z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.756 7.594l.212.145c.493-.674.937-.809 1.388-.455.78.61.847 2.1.014 2.598-.995.595-1.499 1.754-1.058 2.385.407.583 1.388.362 2.356-.37.172-.129.336-.268.49-.413l-.204-.158a5.55 5.55 0 01-.445.374c-.864.652-1.694.839-1.982.427-.343-.492.096-1.503.98-2.031.998-.598.921-2.296.012-3.008-.586-.458-1.192-.274-1.763.506zm3.808 3.051l.21.146c.368-.495.619-1.032.702-1.56l-.256-.038c-.077.487-.311.987-.656 1.452zM27.27 7.594l-.212.145c-.494-.674-.937-.809-1.389-.455-.78.61-.847 2.1-.013 2.598.994.595 1.498 1.754 1.057 2.385-.407.583-1.388.362-2.356-.37a5.826 5.826 0 01-.49-.413l.205-.158c.14.131.289.256.445.374.863.652 1.693.839 1.981.427.344-.492-.096-1.503-.979-2.031-.999-.598-.922-2.296-.013-3.008.586-.458 1.193-.274 1.764.506zm-3.808 3.051l-.212.146c-.367-.495-.618-1.032-.7-1.56l.256-.038c.076.487.31.987.656 1.452z",
      fill: "#979797"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.87 20.016c.287 0 .52-.116.52-.26 0-.143-.233-.259-.52-.259-.286 0-.518.116-.518.26 0 .143.232.259.518.259zM21.785 9.219c1.003 0 1.816-.136 1.816-.303 0-.167-.813-.303-1.816-.303-1.003 0-1.816.136-1.816.303 0 .167.813.303 1.816.303z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.886 2.038h-.259v.299h-.246v.251h.246v.733h.26v-.733h.299v-.251h-.3v-.299zm-1.952 3.618l-.116-.195a3.81 3.81 0 01.195-.075l-.337-.74.237-.102.348.762c.073-.021.149-.04.225-.059a.353.353 0 01-.086-.233c0-.185.136-.335.303-.335.167 0 .303.15.303.335 0 .052-.011.101-.03.145.205-.027.42-.044.643-.05v-.284h-.324v-.202h.324v-.241h.343v.241h.397v.202h-.397v.282c.255.004.494.022.717.053a.362.362 0 01-.03-.146c0-.185.135-.335.302-.335.167 0 .303.15.303.335 0 .094-.036.18-.093.24.097.026.19.055.28.086l.247-.544.238.101-.247.54c.02.01.039.018.057.028l-.13.188-.02-.01-.04.088-.238-.102.04-.085c-.38-.136-.84-.21-1.386-.22v.09h-.343v-.087c-.647.02-1.208.13-1.685.33zm-.116.224l.061.102-.203.087.337.74a3.883 3.883 0 00-.195.076l.116.195c.477-.2 1.038-.31 1.685-.33v.088h.343v-.09c.545.01 1.006.084 1.385.22l-.039.084.238.102.04-.087.02.01.13-.189a2.67 2.67 0 00-.057-.027l.247-.54-.238-.102-.248.545a3.366 3.366 0 00-.28-.085.352.352 0 00.094-.243c0-.185-.136-.334-.303-.334-.167 0-.303.15-.303.334 0 .053.012.103.031.148a5.927 5.927 0 00-.717-.054v-.282h.397v-.202h-.397v-.24h-.343v.24h-.324v.202h.324v.284a6.298 6.298 0 00-.644.05.363.363 0 00.03-.146c0-.185-.135-.334-.302-.334-.167 0-.303.15-.303.334 0 .092.034.175.087.235a4.495 4.495 0 00-.226.059l-.303-.665c.523-.215 1.148-.323 1.875-.323.736 0 1.326.111 1.773.33l.13-.188c-.49-.24-1.125-.36-1.903-.36-.776 0-1.448.119-2.015.356zm0 1.423l.061.102-.203.087.337.74a3.851 3.851 0 00-.195.076l.116.195c.477-.2 1.038-.31 1.685-.33v.088h.343v-.09c.545.01 1.006.084 1.385.22l-.039.084.238.101.04-.086.02.01.13-.189a2.7 2.7 0 00-.057-.027l.247-.541-.238-.101-.248.545a3.352 3.352 0 00-.279-.085.352.352 0 00.093-.242c0-.185-.136-.335-.303-.335-.167 0-.303.15-.303.335 0 .053.011.102.03.147a5.926 5.926 0 00-.716-.054v-.281h.397V7.47h-.397v-.241h-.343v.24h-.324v.203h.324v.283a6.296 6.296 0 00-.643.05.363.363 0 00.03-.145c0-.185-.136-.335-.303-.335-.167 0-.303.15-.303.335 0 .091.033.174.086.234a4.546 4.546 0 00-.225.059l-.303-.665c.523-.215 1.148-.323 1.875-.323.736 0 1.326.11 1.773.33l.13-.189c-.49-.24-1.125-.359-1.903-.359-.776 0-1.448.119-2.015.356zm0 1.424l.116.195c.528-.222 1.161-.333 1.899-.333.736 0 1.326.11 1.773.33l.13-.189c-.49-.24-1.125-.359-1.903-.359-.776 0-1.448.118-2.015.356z",
      fill: "#F4B300"
    }
  ))
), a = c;
export {
  a as default
};
